var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkBrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.62388 19.6108C6.62388 19.6108 1.41334 34.7526 10.7002 33.4081C19.9871 32.0636 33.5553 42.4928 35.0459 29.7907C36.5381 17.0886 34.2713 5.56252 29.479 4.38481C24.6867 3.2071 12.7294 0.28603 6.62388 19.6108Z",
    fill: "#B49D70",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7627 25.2375L25.2377 16.75",
    stroke: "#3F2C26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1251 27.3625L19.5876 30.9C19.0303 31.4573 18.3687 31.8994 17.6406 32.201C16.9124 32.5026 16.132 32.6578 15.3439 32.6578C13.7521 32.6578 12.2256 32.0255 11.1001 30.9C9.97459 29.7745 9.34229 28.248 9.34229 26.6562C9.34229 25.0645 9.97459 23.538 11.1001 22.4125L14.6376 18.875",
    stroke: "#3F2C26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3625 23.1246L30.9 19.5871C32.0255 18.4616 32.6578 16.9351 32.6578 15.3434C32.6578 13.7517 32.0255 12.2251 30.9 11.0996C29.7745 9.9741 28.248 9.3418 26.6562 9.3418C25.0645 9.3418 23.538 9.9741 22.4125 11.0996L18.875 14.6371",
    stroke: "#3F2C26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkBrown);
export default __webpack_public_path__ + "static/media/Link-brown.ae200b6767d4d2f1d62d0f77d2296018.svg";
export { ForwardRef as ReactComponent };